/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Tut_IntroInputs */

const en_pc_tut_intro = /** @type {(inputs: Pc_Tut_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`These PdfCraft tutorials are written for version ${i?.version} of the desktop app, and almost everything also works in PdfCraft Online. Shortcuts show the Mac key first; use Ctrl instead of ⌘ on Windows and Linux. Can't find a tool? Press ⌘K and type its name.`)
};

const zh_pc_tut_intro = /** @type {(inputs: Pc_Tut_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这些 PdfCraft 教程基于桌面版 ${i?.version} 编写，几乎所有内容也适用于 PdfCraft 在线版。快捷键先写 Mac 按键，在 Windows 和 Linux 上用 Ctrl 代替 ⌘。找不到某个工具？按 ⌘K 输入它的名字即可。`)
};

/**
* | output |
* | --- |
* | "These PdfCraft tutorials are written for version {version} of the desktop app, and almost everything also works in PdfCraft Online. Shortcuts show the Mac ke..." |
*
* @param {Pc_Tut_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_intro = /** @type {((inputs: Pc_Tut_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_intro(inputs)
	return zh_pc_tut_intro(inputs)
});
export { pc_tut_intro as "pc.tut.intro" }